import * as Yup from 'yup';
import { InvoiceStatus, InvoiceType, PaymentMethod } from '../../../domain/types';
import type { InvoiceFormProps } from './InvoiceForm';

export const invoiceFormValidationSchema = (
  hiddenFields: InvoiceFormProps['hiddenFields'] = {},
  isValueTotallyPaid = true,
  invoiceStatus?: InvoiceStatus,
) => {
  const {
    invoiceId, proformaInvoiceId, paymentMethod, vat,
  } = hiddenFields;

  const isProformaInvoiceIdRequired = invoiceStatus === InvoiceStatus.PROFORMA;

  return Yup.object({
    type: Yup.string()
      .oneOf(Object.values(InvoiceType))
      .required('Il campo è obbligatorio'),
    value: Yup.string().trim().required('Il campo è obbligatorio'),
    paidValue: isValueTotallyPaid
      ? Yup.string()
      : Yup.string().trim().required('Il campo è obbligatorio'),
    vat: vat
      ? Yup.string().notRequired()
      : Yup.string()
        .trim()
        .required('Il campo è obbligatorio')
        .test(
          'is-valid-percentage',
          'Il valore deve essere compreso tra 0% e 100%',
          (value) => {
            if (value === undefined || value === null || value === '') return false;
            const num = parseFloat(value);
            return !Number.isNaN(num) && num >= 0 && num <= 100;
          },
        ),
    paymentDate: Yup.string().trim().required('Il campo è obbligatorio'),
    paymentMethod: paymentMethod
      ? Yup.string().notRequired()
      : Yup.string().oneOf(Object.values(PaymentMethod)).required('Il campo è obbligatorio'),
    invoiceId: invoiceId
      ? Yup.string().notRequired()
      : Yup.string().trim().required('Il campo è obbligatorio'),
    proformaInvoiceId: (() => {
      if (proformaInvoiceId) {
        return Yup.string().notRequired();
      }
      if (isProformaInvoiceIdRequired) {
        return Yup.string().trim().required('Il campo è obbligatorio');
      }
      return Yup.string();
    })(),
  });
};
